import React, { createContext, useState } from 'react';
import { findIndex, sumBy } from "lodash";
import data from "../../data-api.json";

const MyContext = createContext();

export const GlobalProvider = ({children}) => {
    const [ menu, setMenu ] = useState(true);
    const [ toggleFlash, setDisplayFlash ] = useState(false);
    const [ flashMessage, setFlashMessage ] = useState("");
    const [ basket, addToBasket ] = useState([]);
    const [ timer, setTimer ] = useState(true);
    const [ pizzas, setPizzas ] = useState(data);

    const updateBasket = (basketItem, method = "add") => {
        let index = findIndex(basket, item => item.id === basketItem.id);

        // Item already in basket
        if(index !== -1 && method === "add") {
            let newBasket = [...basket];
            newBasket[index] = { ...newBasket[index], quantity: newBasket[index].quantity + 1};
            addToBasket(newBasket);
            return;
        }
        if(index !== -1 && method === "remove") {
            let newBasket = [...basket];
            newBasket[index] = { ...newBasket[index], quantity: newBasket[index].quantity - 1};
            if(newBasket[index].quantity === 0) {
                newBasket.splice(index, 1);
            }
            addToBasket(newBasket);
            return;
        }
        addToBasket([...basket, basketItem]);
    }

    const displayFlash = (text) => {
        if(timer === true) {
        setTimer(false);
        setDisplayFlash(!toggleFlash);
        setTimeout(() => {
            setDisplayFlash(false);
            setTimer(true);
        }, 1800);
        }
    }

    const filterPizzas = (search) => {
        const filteredPizzas = data.filter(pizza => {
            return pizza.title.includes(search)
        })
        setPizzas(filteredPizzas);
    }
    
    const contextValue = {
        menu: menu,
        toggleMenu: setMenu,
        data: pizzas,
        addToBasket: updateBasket,
        basket,
        total: sumBy(basket, (item) => item.price * item.quantity).toFixed(2),
        displayFlash: displayFlash,
        toggleFlash,
        flashMessage,
        setFlashMessage,
        filterPizzas
    }
    return (
        <MyContext.Provider value={contextValue}>
            {children}
        </MyContext.Provider>
    )

}

export default MyContext;